export function fromStringsArray(items: string[]) {
	return items.map((x) => ({
		label: x,
		value: x,
	}));
}
